import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import useNavModel from '../model/navModel'
import menuData from '../data/menuData.json'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { Tag } from 'antd'
import { DownOutlined, DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons'
import { IMenuNode } from './AppMenu'
import navCloseIcon from '@/assets/images/nav_close.png'
import navCloseActiveIcon from '@/assets/images/nav_close_active.png'

const NavBox = SortableContainer((props: any) => (
    <div className="layout-section-nav" {...props}>
        {props.children}
    </div>
))
const Nav = SortableElement((props: any) => <>{props.children}</>)

function getNavSelectedMenu(menuData: IMenuNode[], menuId: String) {
    function filterMenus(menus: IMenuNode[]): IMenuNode | undefined {
        for (const menu of menus) {
            if (menu.id === menuId) return menu
            if (menu.children && menu.children.length > 0) {
                const ret = filterMenus(menu.children)
                if (ret) return ret
            }
        }
    }

    return filterMenus(menuData)
}

function AppNav() {
    const history = useHistory()
    const location = useLocation()

    const { navTabs, selectedNavId, getSelectedNavState, selectNav, closeNav, sortNav } = useNavModel()

    useEffect(() => {
        const page = getNavSelectedMenu(menuData, selectedNavId)
        if (page) {
            //路由是否变化
            if (location.pathname !== page.path && location.pathname !== '/login')
                // console.log(Nav.getSelectNode('state'), history, "nav切换")
                history.push({ pathname: page.path, state: getSelectedNavState() })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedNavId])


    let scroll = ( val: "left" | "right") => {

        let scroolEle = document.getElementById('nav-center-box') as HTMLElement
        let scrollWidth = scroolEle.scrollWidth  as number; 
        let scrollLeft = scroolEle.scrollLeft  as number;
        let moveVal = 200
        let scrollVal = val === "left" ? scrollLeft - moveVal : scrollLeft + moveVal
        if(scrollVal < 0){
            scrollVal = 0
        }else if(scrollVal > scrollWidth){
            scrollVal = scrollWidth
        }
        console.log(scrollVal)
        console.log(scrollVal)
        console.log(scrollVal)
        console.log(scrollVal)
        console.log(scrollVal)
        scroolEle.scrollTo({
            left: scrollVal,
            behavior: "smooth"
        }) 
                
    }

    return (
        // <NavBox
        //     distance={20}
        //     transitionDuration={200}
        //     axis="x"
        //     onSortEnd={sortNav}>
        //     {
        //         navTabs.map((item, index) => (
        //             <Nav
        //                 key={item.id}
        //                 index={index}
        //             >
        //                 <Tag
        //                     key={item.id}
        //                     closable={item.closable}
        //                     className={["non-copyable", item.id === selectedNavId ? "tag-checked" : ""].join(' ')}
        //                     onClick={() => selectNav(item.id)}
        //                     onClose={() => closeNav(item.id)}
        //                 >
        //                     {item.name}
        //                 </Tag>
        //             </Nav>
        //         ))
        //     }
        // </NavBox>
        <div className="nav-box">
            <div className="nav-left nav-icon" onClick={() => {scroll("left")}}>
                {/* <img src={navLeftIcon} /> */}
                <DoubleLeftOutlined />
            </div>
            <div className="nav-center" id="nav-center-box">
                <div className="nav-center-box" >
                    {navTabs.map((item, index) => (
                        <Tag
                            key={item.id}
                            closable={item.closable}
                            className={['non-copyable', 'nav', item.id === selectedNavId ? 'tag-checked' : ''].join(' ')}
                            onClick={() => selectNav(item.id)}
                            onClose={() => closeNav(item.id)}
                        >
                            {item.name}
                        </Tag>
                    ))}
                </div>
            </div>
            <div className="nav-right nav-icon"  onClick={() => {scroll("right")}}>
                {/* <img src={navRightIcon} /> */}
                <DoubleRightOutlined />
            </div>
            <div className="nav-right nav-icon">
                <DownOutlined />
            </div>
        </div>
    )
}

export default AppNav
